function getAuthByRole(screen, roles) {
  const formattedRoles = roles.map(role =>
    role.toLowerCase().replace(/\s/g, ''),
  )
  return screen.some(role => formattedRoles.includes(role))
}

export {getAuthByRole}
